import type { ReactNode } from 'react';

import styles from './legacy-modal-body-content.component.module.scss';

type Props = {
  children?: ReactNode;
};

/**
 * @deprecated Use `@findy-code/yuffie/ui` instead.
 */
export const LegacyModalBodyContent = ({ children }: Props) => {
  return <div className={styles.modalBodyContent}>{children}</div>;
};
